<template>
    <div v-if="formData">
        <app-form 
            v-bind:parentObject = "{
                data: this.formData,
                dataParameter: this.formDataParameter,
                parameters: this.parameters,
                // staffList: this.staffList,
                pageTitle: this.pageTitle,
                pageTitleValue: this.pageTitleValue,
                errMsg: this.errMsg,
                isEdit: this.editMode
            }"
        />
        <div v-if="isErr">
            <app-error 
                v-bind:parentError ="{
                    data: this.errMsg,
                    isErr: this.isErr
                }"
            />
        </div>    
    </div>
</template>

<script>
import ReviewExerciseGenerateForm from '../../../components/performance/reviewexercise/Form_Parameter';
import ErrorDialog from '../../../components/common/ErrorDialog';

export default {
    components: {
        'app-form': ReviewExerciseGenerateForm,
        'app-error': ErrorDialog
    },

    data() {
        return{
            pageTitle: this.$t('pmreviewexercise.generateappraisalexercise'),
            pageTitleValue: this.$route.params.formData.reviewcode,

            formData: this.$route.params.formData,
            formDataParameter: this.$route.params.formDataParameter,
            parameters: this.$route.params.parameters,

            staffList: [],
            statusList: [],

            errMsg: '',
            isErr:false,
            editMode: false 
        }
    },

    mounted(){
        console.log("HERE1");
    }
}

</script>